import { defineSlotRecipe } from '@chakra-ui/react';

export const conversationCardSlotRecipe = defineSlotRecipe({
	base: {
		cell: { padding: '24px' },

		body: {
			border:        '1px solid',
			borderColor:   '#EAEAEA',
			borderRadius:  '8px 8px 0px 8px',
			display:       'flex',
			flexDirection: 'row',
			padding:       '0px',
		},
		deleteButton: {
			border:       '1px solid',
			borderColor:  '#EAEAEA !important',
			borderRadius: '0px 0px 8px 8px',
			padding:      '8px 24px',
		},
		footer: {
			display:        'flex',
			justifyContent: 'flex-end',
			padding:        0,
		},
		root: {
			border:  0,
			padding: 0,
		},
	},
	slots: [
		'root', 'cell', 'body', 'footer', 'deleteButton',
	],
});
